import React, {PureComponent} from 'react'
import {postRequest} from "../../api";
import Layout from "../Simple/Layout";
import TextInput from "../Simple/TextInput";
import TextEditor from "../Simple/TextEditor";

export default class AdminItemForm extends PureComponent {
  state = {}

  componentWillMount() {
    const {
      item,
      config
    } = this.props

    let initState = {}

    for (let field of config.fields) {
      initState[field.name] = item[field.name] ? item[field.name] : ''
    }

    this.setState(initState)
  }

  onSubmitForm = (e) => {
    e.preventDefault()
    const url = this.props.config.url
    const confirmationMessage = this.props.config.confirmationMessage

    const payload = this.state
    let content = prompt(confirmationMessage);
    if (content === 'Y') {
      postRequest(url, payload).then((response) => {
        alert(response.message)
      }).catch((response) => {
        if (response && response.message) {
          alert(response.message)
        } else {
          alert('Error.')
        }
      })
    }
  }
  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }
  handleContractChange = (value) => {
    this.setState({contract: value})
  }

  render() {
    const {
      item,
      config
    } = this.props

    return (
        <form onSubmit={this.onSubmitForm}>
          <Layout className="row">
            {
              config.fields && config.fields.map((field, fieldKey) => {
                if (field.type === 'text') {
                  return (
                      <Layout className="col-md-6" marginBottomHalf key={fieldKey}>
                        <TextInput
                            name={field.name}
                            label={field.label}
                            placeholder={field.placeholder}
                            value={this.state[field.name]}
                            onChange={this.handleChange}
                        />
                      </Layout>
                  )
                }
                if (field.type === 'textArea') {
                  return (
                      <Layout className="col-md-12" marginBottomHalf key={fieldKey}>
                        <TextEditor
                            value={this.state[field.name]}
                            onChange={this.handleContractChange}
                        />
                      </Layout>
                  )
                }
              })
            }
            <Layout className="col-md-6">
              <button className="btn btn-primary btn-sm mb-3">{config.submitLabel}</button>
            </Layout>
          </Layout>
        </form>
    )
  }
}
